import { render, staticRenderFns } from "./DiscountCodes.vue?vue&type=template&id=2dab94e5&"
import script from "./DiscountCodes.vue?vue&type=script&lang=js&"
export * from "./DiscountCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dab94e5')) {
      api.createRecord('2dab94e5', component.options)
    } else {
      api.reload('2dab94e5', component.options)
    }
    module.hot.accept("./DiscountCodes.vue?vue&type=template&id=2dab94e5&", function () {
      api.rerender('2dab94e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscountCodes.vue"
export default component.exports